import {MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {Component} from '@angular/core';

@Component({
  selector: 'ps-upload-tool-acceptance-report',
  templateUrl: 'upload-toolacceptance-report.component.html'
})
export class UploadToolacceptanceReportComponent {

  selectedFiles: FileList;

  constructor(private bottomSheetRef: MatBottomSheetRef) {
  }

  onFilesChanged(files: FileList) {
    this.selectedFiles = files;
  }

  save() {
    this.bottomSheetRef.dismiss(this.selectedFiles);
  }

  dismiss() {
    this.bottomSheetRef.dismiss();
  }

}
